

import Vue, {PropType} from "vue";
import {BIconX, BIconChevronCompactLeft, BIconChevronCompactRight} from "bootstrap-vue";
import {asDisposable, EmptyDisposable} from "kistenkonfigurator/build/util/Disposable";
import {KeyCodes} from "../../util/keyEvent-util";
import {ImageGalleryImageModel} from "../../model/ImageGalleryImageModel";

/**
 *
 */
export default Vue.extend({
  name: "ImageGallery",
  components: {
    BIconX,
    BIconChevronCompactLeft,
    BIconChevronCompactRight,
  },
  props: {
    value: {
      type: Boolean as PropType<boolean>,
      default: () => false,
      required: true,
    },
    initialIndex: {
      type: Number as PropType<number>,
      default: () => 0,
    },
    images: {
      type: Array as PropType<Array<ImageGalleryImageModel>>,
      default: () => [],
      required: true,
    },
  },
  data() {
    return {
      imageIndex: this.initialIndex,
      listenerDisposable: EmptyDisposable,
    };
  },
  computed: {
    currentImage(): ImageGalleryImageModel {
      const index = this.imageIndex < 0
        ? 0
        : (this.imageIndex > this.images.length ? this.images.length - 1 : this.imageIndex);
      return this.images[index];
    },
  },
  watch: {
    initialIndex() {
      this.imageIndex = this.initialIndex;
    },
    value() {
      this.registerKeyListener();
    },
  },
  methods: {
    registerKeyListener() {
      if (!this.value) {
        return;
      }

      // Safely remove any previous registered listener, in case we have a bug somewhere and the gallery opens twice.
      this.listenerDisposable.dispose();

      const listener = (e: KeyboardEvent) => {
        if (e.keyCode === KeyCodes.DOM_VK_LEFT) {
          this.previous(e);
        } else if (e.keyCode === KeyCodes.DOM_VK_RIGHT) {
          this.next(e);
        } else if (e.keyCode === KeyCodes.DOM_VK_ESCAPE) {
          this.close();
        }
      };
      document.addEventListener("keydown", listener);

      this.listenerDisposable = asDisposable(() => {
        document.removeEventListener("keydown", listener);
      });
    },
    close() {
      this.listenerDisposable.dispose();
      this.$emit("input", false);
    },
    next(event: Event) {
      event.stopPropagation();
      this.imageIndex = (this.imageIndex + 1) % this.images.length;
    },
    previous(event: Event) {
      event.stopPropagation();
      this.imageIndex = this.imageIndex - 1 >= 0 ? this.imageIndex - 1 : this.images.length - 1;
    },
  },
});
